import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import { Box, SpinnerAlpha, Stack } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import CustomerApi from '../api/customer/CustomerApi';
import { ShoppingBudgetBlock } from '../components/shopping-budget/ShoppingBudgetBlock';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
import { getQuerystringByName } from '../util/URLParamUtil';
var ShoppingBudgetStatus;
(function (ShoppingBudgetStatus) {
    ShoppingBudgetStatus["PENDING"] = "pending";
    ShoppingBudgetStatus["VALID"] = "valid";
    ShoppingBudgetStatus["INVALID"] = "invalid";
    ShoppingBudgetStatus["ERROR"] = "error";
})(ShoppingBudgetStatus || (ShoppingBudgetStatus = {}));
const URL_UUID_PARAM_NAME = 'customerUuid';
const URL_VOUCHER_ONE_PARAM_NAME = 'voucherId1';
const URL_VOUCHER_TWO_PARAM_NAME = 'voucherId2';
const ANALYTICS_ERROR_GENERAL = 'error';
const ANALYTICS_ERROR_USED = 'alreadyused';
const ANALYTICS_ERROR_INVALID = 'expired';
const ANALYTICS_ERROR_ACTIVE = 'alreadyactivated';
const ShoppingBudgetContainer = ({ successPage, backgroundImage, isAlreadyActivated, isAlreadyUsed, isExpired, standardError, }) => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const dispatch = useDispatch();
    const [status, setStatus] = useState(ShoppingBudgetStatus.PENDING);
    const [uniqueVouchers, setUniqueVouchers] = useState([]);
    const setPaybackVouchers = (uuid, vouchers) => __awaiter(void 0, void 0, void 0, function* () {
        return yield CustomerApi.postPaybackVouchers(servicesEndpoint, defaultRequestParams, uuid, vouchers);
    });
    const getAnalyticsError = (voucher) => {
        switch (voucher.messageCode) {
            case 'voucher.used':
                return ANALYTICS_ERROR_USED;
            case 'voucher.invalid':
                return ANALYTICS_ERROR_INVALID;
            case 'already.active':
                return ANALYTICS_ERROR_ACTIVE;
            default:
                return ANALYTICS_ERROR_GENERAL;
        }
    };
    const getShoppingBudgetStatus = (voucher) => {
        switch (voucher.messageCode) {
            case 'voucher.used':
                return isAlreadyUsed;
            case 'voucher.invalid':
                return isExpired;
            case 'already.active':
                return isAlreadyActivated;
            default:
                return standardError;
        }
    };
    useEffect(() => {
        const uuid = getQuerystringByName(window.location.search, URL_UUID_PARAM_NAME);
        const voucher1 = getQuerystringByName(window.location.search, URL_VOUCHER_ONE_PARAM_NAME);
        const voucher2 = getQuerystringByName(window.location.search, URL_VOUCHER_TWO_PARAM_NAME);
        const vouchers = [voucher1, voucher2].filter(Boolean);
        if (!!uuid && !!vouchers && vouchers.length > 0) {
            const params = window.location.search.substring(0);
            setPaybackVouchers(uuid, vouchers)
                .then(() => {
                setStatus(ShoppingBudgetStatus.VALID);
                EventUtil.dispatch(EventEnum.LATITUDE_USER_LOGGED_IN, { redirectUrl: `${successPage}${params}` });
            })
                .catch(err => {
                const errVouchers = err.response.data.vouchers;
                if (errVouchers) {
                    setStatus(ShoppingBudgetStatus.INVALID);
                    setUniqueVouchers(errVouchers
                        .filter(voucher => !voucher.valid)
                        .filter((value, index, array) => array.findIndex(voucher => voucher.messageCode === value.messageCode) === index));
                    dispatch(analyticsActions.paybackError(getAnalyticsError(errVouchers[0])));
                }
                else {
                    setStatus(ShoppingBudgetStatus.ERROR);
                    dispatch(analyticsActions.paybackError(ANALYTICS_ERROR_GENERAL));
                }
            });
        }
        else {
            setStatus(ShoppingBudgetStatus.ERROR);
            dispatch(analyticsActions.paybackError(ANALYTICS_ERROR_GENERAL));
        }
    }, []);
    return (_jsxs(Box, { paddingBlockStart: { base: '6', md: '8', lg: '14' }, paddingBlockEnd: { lg: '6' }, marginInline: "-2", children: [status === ShoppingBudgetStatus.PENDING && (_jsx(Stack, { justify: "center", children: _jsx(SpinnerAlpha, { size: "lg", color: "brand" }) })), status === ShoppingBudgetStatus.ERROR && (_jsx(ShoppingBudgetBlock, Object.assign({ backgroundImage: backgroundImage }, standardError))), status === ShoppingBudgetStatus.INVALID &&
                uniqueVouchers.map(voucher => (_jsx(ShoppingBudgetBlock, Object.assign({ backgroundImage: backgroundImage }, getShoppingBudgetStatus(voucher)), voucher.barcode)))] }));
};
export default ShoppingBudgetContainer;
